import { usePortalSettings } from '@servicetitan/cp-ui';
import { BodyText, Button, Spinner, Stack } from '@servicetitan/design-system';
import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import { BannerStyleStatus } from '../../../common/utils/banner-settings';
import * as Styles from './auth.layout.module.less';
import { SignInBanner } from './sign-in-banner';

export const AuthLayout: FC<{
    loading?: boolean;
    children?: ReactNode;
    showSignInBanner?: boolean;
}> = ({ children, loading, showSignInBanner = true }) => {
    const settings = usePortalSettings();

    return (
        <div className={Styles.shell}>
            {showSignInBanner && <SignInBanner style={BannerStyleStatus.Announcement} />}
            <div className={classNames('w-100vh', Styles.container)}>
                <Stack.Item className={Styles.portraitPattern} />
                <Stack className={classNames('bg-neutral-0', Styles.authColumn)} direction="column">
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        className="flex-grow-1 flex-basis-0"
                    >
                        <div className={classNames(Styles.form)}>
                            <div
                                className={classNames(
                                    'd-f flex-row justify-content-center',
                                    Styles.logoContainer
                                )}
                            >
                                <img
                                    src={settings?.logo}
                                    className={Styles.logo}
                                    alt={settings?.title}
                                />
                            </div>
                            {showSignInBanner && <SignInBanner style={BannerStyleStatus.Alert} />}
                            <div className={classNames(Styles.content, 'p-x-2')}>
                                {loading ? (
                                    <Stack className="w-100" justifyContent="center">
                                        <Spinner />
                                    </Stack>
                                ) : (
                                    children
                                )}
                            </div>
                        </div>
                    </Stack>
                    <Stack
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        className="w-100 p-t-3 p-b-5"
                    >
                        {!!settings?.phoneNumberFormatted && (
                            <Button
                                href={`tel:${settings.phoneNumber}`}
                                fill="subtle"
                                iconName="phone"
                                className="border border-radius-2 m-y-2"
                            >
                                {settings.phoneNumberFormatted}
                            </Button>
                        )}
                        <BodyText size="xsmall" className="opacity-disabled m-t-2">
                            POWERED BY
                        </BodyText>
                        <img
                            className={Styles.stLogo}
                            src="https://static.servicetitan.com/portal/st-logo.png"
                            alt="Powered by ServiceTitan"
                        />
                    </Stack>
                </Stack>
                <Stack.Item className={Styles.portraitPattern} />
            </div>
        </div>
    );
};
